import { proxy } from '@/utils'

import render from './render'

export default {
  name: 'Form',

  mixins: [ proxy({ type: 'object' }) ],

  props: {
    dictionary: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  render
}
